import BigNumber from 'bignumber.js';
import numeral from 'numeral';

export function format(input, currency = '€', numberFormat = '0,0.00[0000]', pattern = '{m} {c}') {
  const num = new BigNumber(input);
  // eslint-disable-next-line no-useless-assignment
  let value = null;

  if (num.isNaN() || num.isEqualTo(0)) {
    value = 0;
  } else {
    value = num.toString();
  }

  return pattern
    .replace('{m}', numeral(value).format(currency === '¥' ? '0' : numberFormat).replace(/,/gu, ' '))
    .replace('{c}', currency);
}

export function formatNumber(value, numberFormat = '0,0.[0000]') {
  return numeral(value).format(numberFormat);
}

export function gt(a, b) {
  return new BigNumber(a).isGreaterThan(b);
}
